
import $ from 'jquery';
import plugin from '@core/plugins/lib';

export const ELEMENT_SELECTOR = '[data-transport-element]';
export const PLUGIN_NAME = 'TransportElement';

$(() => {
	$(ELEMENT_SELECTOR).each(function() {
		const element = this;
		System.import(/* webpackChunkName: "plugin--transport-element" */ './transport-element'
		).then((module) => {
			plugin(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
});



// WEBPACK FOOTER //
// ./client/src/core/plugins/jquery__transport-element/plugin--split.js